import React, { Component } from 'react'
import { connect } from 'react-redux'
import { selectors as UsersSelectors } from 'data/users'
import { compose } from 'recompose'

import {
  actions as InvitesActions,
  selectors as InvitesSelectors,
} from 'data/invites'
import SendInvitationsForm from 'components/Invitations/SendInvitationsForm'
import { Button, Text } from 'components/base'
import InvitationsList from './List'

export class Invitations extends Component {
  componentDidMount() {
    this.props.fetchInvites()
  }
  render() {
    const {
      invites,
      resend,
      deleteInviteStatuses,
      deleteInvite,
      resendInvite,
      canInvite,
    } = this.props

    if (!canInvite) {
      return (
        <div>
          You must be owner or admin of your team to access these settings
        </div>
      )
    }

    return (
      <div className="padding-vertical-large">
        <Text.Subtitle className="margin-bottom-larger">
          Invite people
        </Text.Subtitle>
        <SendInvitationsForm>
          {({ getEmails, onSubmit }) => (
            <div className="flexbox flexbox-space-between margin-top-larger">
              <Button.Primary
                disabled={!Boolean(getEmails().length)}
                onClick={onSubmit}
              >
                Send invitations
              </Button.Primary>
            </div>
          )}
        </SendInvitationsForm>
        {invites.data &&
          invites.data.length > 0 && (
            <Text.Subtitle className="margin-bottom-large margin-top-larger">
              Invitations sent
            </Text.Subtitle>
          )}
        <InvitationsList
          className="margin-bottom-larger background-shade-100"
          invites={invites}
          resend={resend}
          deleteInviteStatuses={deleteInviteStatuses}
          deleteInvite={deleteInvite}
          resendInvite={resendInvite}
          style={{ maxHeight: 200 }}
        />
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
    invites: InvitesSelectors.getInvitesList(state),
    resend: InvitesSelectors.getInvitesResend(state),
    deleteInviteStatuses: InvitesSelectors.getInvitesDelete(state),
    canManage: UsersSelectors.canCurrentUserManageOrganization(state),
    canInvite: UsersSelectors.canCurrentUserInviteMembers(state),
  }
}

const mapDispatchToProps = {
  fetchInvites: InvitesActions.fetchInvites,
  resendInvite: InvitesActions.resendInvite,
  deleteInvite: InvitesActions.deleteInvite,
}

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Invitations)
